import Layout from '@/layout'
import { getCookie } from '../assets/js/cookie';

let redirectUrl = "";

if (getCookie()) {
  redirectUrl = "/home";
} else {
  redirectUrl = "/login";
}
const routes = [
  {
    path: '/',
    redirect: redirectUrl
  },
  {
      name: 'login',
      path: '/login',
      component: () => import('@/views/login')
  },
  {
    name: 'register',
    path: '/register',
    component: () => import('@/views/login/register')
  },
  {
    name: 'transfer',
    path: '/transfer',
    component: () => import('@/views/transfer')
  },
  {
    path: '/home',
    component: Layout,
    children: [{
      path: '/home',
      name: 'home',
      component: () => import('@/views/home')
    }]
  },
  {
    path: '/recycle',
    component: Layout,
    children: [{
      path: '/recycle',
      name: 'recycle',
      component: () => import('@/views/recycle')
    }]
  },
  {
    path: '/todo',
    component: Layout,
    children: [{
      path: '/todo',
      name: 'todo',
      component: () => import('@/views/todo')
    }]
  },
  {
    path: '/results',
    component: Layout,
    children: [{
      path: '/results',
      name: 'results',
      component: () => import('@/views/results')
    }]
  },
  {
    path: '/applicant',
    component: Layout,
    children: [{
      path: '/applicant',
      name: 'applicant',
      component: () => import('@/views/applicant')
    }]
  },
  {
    path: '/order-detail',
    component: Layout,
    children: [{
      path: '/order-detail',
      name: 'orderDetail',
      component: () => import('@/views/orderDetail')
    }]
  },
  {
    path: '/confirm',
    component: Layout,
    children: [{
      path: '/confirm',
      name: 'confirm',
      component: () => import('@/views/confirm')
    }]
  },
  {
    path: '/correction',
    component: Layout,
    children: [{
      path: '/correction',
      name: 'correction',
      component: () => import('@/views/correction')
    }]
  },
  {
    path: '/member',
    component: Layout,
    children: [{
      path: '/member',
      name: 'member',
      component: () => import('@/views/member')
    }]
  },
  {
    path: '/notice',
    component: Layout,
    children: [{
      path: '/notice',
      name: 'notice',
      component: () => import('@/views/notice')
    }]
  },
  {
    path: '/notice-detail',
    component: Layout,
    children: [{
      path: '/notice-detail',
      name: 'noticeDetail',
      component: () => import('@/views/noticeDetail')
    }]
  },
  {
    path: '/data-center',
    component: Layout,
    children: [{
      path: '/data-center',
      name: 'dataCenter',
      component: () => import('@/views/dataCenter')
    }]
  },
  {
    name: 'auth',
    path: '/auth',
    component: () => import('@/views/auth')
  },
  {
    name: 'pdf-preview',
    path: '/pdf-preview',
    component: () => import('@/views/pdfPreview')
  },
  {
    path: '/record',
    component: Layout,
    children: [{
      path: '/record',
      name: 'record',
      component: () => import('@/views/record')
    }]
  },
  {
    path: '/company',
    mate: {keepAlive: true},
    component: Layout,
    children: [{
      path: '/company',
      name: 'company',
      component: () => import('@/views/company')
    }]
  },
  {
      path: '/new',
      component: Layout,
      children: [{
        path: '/new',
        name: 'new',
        component: () => import('@/views/new')
      }]
  },
  {
    path: '/new-manual',
    component: Layout,
    children: [{
      path: '/new-manual',
      name: 'newManual',
      component: () => import('@/views/newManual')
    }]
  },
  {
    path: '/submit',
    component: Layout,
    children: [{
      path: '/submit',
      name: 'submit',
      component: () => import('@/views/submit')
    }]
  },
  {
    path: '/auto-review',
    component: Layout,
    children: [{
      path: '/auto-review',
      name: 'autoReview',
      component: () => import('@/views/autoReview')
    }]
  },
  {
    path: '/setting',
    component: Layout,
    children: [{
      path: '/setting',
      name: 'setting',
      component: () => import('@/views/setting')
    }]
  },
  {
    path: '/add-applicant',
    component: Layout,
    children: [{
      path: '/add-applicant',
      name: 'addApplicant',
      component: () => import('@/views/addApplicant')
    }]
  },
  {
    path: '/package',
    component: Layout,
    children: [{
      path: '/package',
      name: 'package',
      component: () => import('@/views/package')
    }]
  },
  {
    path: '/packageRecord',
    component: Layout,
    children: [{
      path: '/packageRecord',
      name: 'packageRecord',
      component: () => import('@/views/packageRecord')
    }]
  },
  {
    path: '/package-list',
    component: Layout,
    children: [{
      path: '/package-list',
      name: 'packageList',
      component: () => import('@/views/packageList')
    }]
  },
  {
    path: '/correction-list',
    component: Layout,
    children: [{
      path: '/correction-list',
      name: 'correctionList',
      component: () => import('@/views/correctionList')
    }]
  },
  {
    path: '/aftersale',
    component: Layout,
    children: [{
      path: '/aftersale',
      name: 'aftersale',
      component: () => import('@/views/aftersale')
    }]
  },
  {
    path: '/printing-materials',
    component: Layout,
    children: [{
      path: '/printing-materials',
      name: 'printingMaterials',
      component: () => import('@/views/printingMaterials')
    }]
  },
  {
    name: 'applyform',
    path: '/applyform',
    component: () => import('@/views/applyform')
  },
  {
    name: 'noticeBook',
    path: '/notice-book',
    component: () => import('@/views/noticeBook')
  },
  {
    name: 'correctionNotice',
    path: '/correction-notice',
    component: () => import('@/views/correctionNotice')
  },
  {
    name: 'correctionHdNotice',
    path: '/correction-hd-notice',
    component: () => import('@/views/correctionHdNotice')
  },
  {
    name: 'noticeHdBook',
    path: '/notice-hd-book',
    component: () => import('@/views/noticeHdBook')
  },
  {
    name: 'verification',
    path: '/verification',
    component: () => import('@/views/verification')
  },
  {
    path: '/submit-result',
    component: Layout,
    children: [{
      path: '/submit-result',
      name: 'submitResult',
      component: () => import('@/views/submitResult')
    }]
  },
  {
    name: 'userAgreement',
    path: '/userAgreement',
    component: () => import('@/views/userAgreement')
  },
  {
    name: 'privacy',
    path: '/privacy',
    component: () => import('@/views/privacy')
  },
  {
    name: 'stop-service',
    path: '/stop-service',
    component: () => import('@/views/stopService')
  },
  {
    path: "/:catchAll(.*)", // 不识别的path自动匹配404
    name: 'NotFound',
    component: () => import('@/views/404')
  }
];

export default routes
